import {get} from 'lodash';
import {Observable} from 'rxjs';
import {Http, URLSearchParams} from '@angular/http';
import {Injectable} from '@angular/core';
import {AbstractService} from '../../../core/http';
import {Customer, CustomerAccount, SmartCustomer} from '../entity/customer';
import {ShortUserProfileInfo} from '../entity/user.profile';
import {CustomerProfile} from '../../../modules/customers/shared/api/entity';
import {DictionaryObject} from '../../../../../common/api';
import {ProfileSettings} from '../../../modules/customers/shared/api/entity/profile-settings';

const MIN_SEARCH_QUERY_LENGTH = 3;

@Injectable()
export class CustomerService extends AbstractService {

    constructor(private _http: Http) {
        super();
    }

    findCustomers(name: string, states?: string[]): Observable<Customer[]> {
        if (name && name.length >= MIN_SEARCH_QUERY_LENGTH) {
            const search: URLSearchParams = new URLSearchParams;
            search.append('query', name);
            if (!!states) {
                search.append('states', String(states.join(',')));
            }

            return this._http
                .get('/api/backoffice/customers/search', {search})
                .map(response => response.json())
                .map(response => get(response, 'records', []));
        } else {
            return Observable.of([]);
        }
    }

    findCustomersRevenueInternal(name: string, numberRevenueInternal: string): Observable<Customer[]> {
        if (name && name.length >= MIN_SEARCH_QUERY_LENGTH) {
            const search: URLSearchParams = new URLSearchParams;
            const query = `${name}|${numberRevenueInternal}`;
            search.append('query', query);

            return this._http
                .get('/api/backoffice/customers/search', {search})
                .map(response => response.json())
                .map(response => get(response, 'records', []));
        } else {
            return Observable.of([]);
        }
    }

    findCustomersById(id: number, apiUrl: string): Observable<Customer[]>{
        if (!!id) {
            const search: URLSearchParams = new URLSearchParams;
            search.append('id', String(id));

            return this._http
                .get(apiUrl, {search})
                .map(response => response.json())
                .map(response => get(response, 'records', []));
        } else {
            return Observable.of([]);
        }
    }

    findLightCustomers(name: string, states?: string[]): Observable<SmartCustomer[]> {
        if (name && name.length >= MIN_SEARCH_QUERY_LENGTH) {
            const search: URLSearchParams = new URLSearchParams;
            search.append('query', name);
            if (!!states) {
                search.append('states', String(states.join(',')));
            }

            return this._http
                .get('/api/backoffice/customers/light-search', {search})
                .map(response => response.json())
                .map(response => get(response, 'records', []));
        } else {
            return Observable.of([]);
        }
    }

    getCustomerAccounts(id: number): Observable<CustomerAccount[]> {
        return this._http
            .get(`/api/backoffice/customers/${id}/accounts`)
            .map(response => response.json())
            .map(response => get(response, 'accounts', []))
    }

    getCustomerAccountsRevenueInternal(id: number, account: string): Observable<CustomerAccount[]> {
        return this._http
            .get(`/api/backoffice/customers/${id}/accounts/${account}/revenue_internal`)
            .map(response => response.json())
            .map(response => get(response, 'accounts', []))
    }

    getCustomersForIncomingTransfers(id: number): Observable<CustomerAccount[]> {
        return this._http
            .get(`/api/backoffice/customers/${id}/accounts?incoming-transfer`)
            .map(response => response.json())
            .map(response => get(response, 'accounts', []))
    }

    getUsersByProfile(id : number) : Observable<ShortUserProfileInfo[]> {
        return this._http.get(`/api/backoffice/customers/${id}/clients?names`).map(response => response.json());
    }

    getResetTokenForUser(userId: number): Observable<String> {
        return this._http.get(`/api/backoffice/customers/clients/${userId}/passwords?reset_link`)
            .map(response => response.json().link);
    }

    getCustomersType(): Observable<DictionaryObject[]> {
        return this._http.get(`/api/backoffice/customers/types`)
            .map(response => response.json());
    }

    getCustomerTariff(type: string): Observable<DictionaryObject[]> {
        return this._http.get(`/api/backoffice/tariff?${type}`)
            .map(response => response.json());
    }

    getCustomerRiskLevel(): Observable<DictionaryObject[]> {
        return this._http.get(`/api/client/dictionary/risk_levels`)
            .map(response => response.json().riskLevels);
    }

    getSingleCustomer(id: number): Observable<CustomerProfile> {
        return this._http.get(`/api/backoffice/customers/${id}`)
            .map(response => response.json());
    }

    updateProfileSettings(id: number, profileSettings: ProfileSettings): Observable<ProfileSettings> {
        return this._http.patch(`/api/backoffice/customers/${id}/profile-settings`, profileSettings)
            .map(response => response.json());
    }

    checkNewProfileKindPossibility(id: number, newProfileKindId: number): Observable<boolean> {
        const search: URLSearchParams = new URLSearchParams;
        search.append('kindId', String(newProfileKindId));
        return this._http.get(`/api/backoffice/customers/${id}?check`, {search: search})
            .map(response => response.json());
    }

    sendVerificationCode(id: number): Observable<boolean> {
        return this._http.get(`/api/backoffice/customers/verification/${id}`)
            .map(response => response.json());
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/customer.service.ts